const doc = [({"en":({"js":({"block_ui":({"please_wait":"Please wait..."})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;